{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "page": {
    "title": "Équipes",
    "subtitle": "Regroupez les boutiques en équipes — chaque équipe ne voit que ses propres données et son budget"
  },
  "actions": {
    "create": "Créer une équipe",
    "edit": "Modifier",
    "deactivate": "Désactiver l'équipe"
  },
  "col": {
    "team": "Équipe",
    "stores": "Boutiques",
    "members": "Membres",
    "spending": "Dépenses",
    "status": "Statut",
    "actions": "Actions"
  },
  "cell": {
    "stores": "{{count}} boutiques",
    "storesOne": "{{count}} boutique"
  },
  "status": {
    "Active": "Active",
    "Inactive": "Inactive"
  },
  "menu": {
    "edit": "Modifier",
    "deactivate": "Désactiver l'équipe"
  },
  "unassigned": {
    "count": "{{count}} boutiques non affectées à une équipe",
    "countOne": "{{count}} boutique non affectée à une équipe",
    "hint": "Vous seul et les administrateurs pouvez voir leurs données jusqu'à leur affectation",
    "assign": "Affecter à une équipe"
  },
  "form": {
    "createTitle": "Créer une équipe",
    "editTitle": "Modifier l'équipe",
    "name": "Nom de l'équipe",
    "namePlaceholder": "ex. : US Market",
    "nameRequired": "Saisissez un nom d'équipe",
    "stores": "Boutiques",
    "storesPlaceholder": "Assignez au moins une boutique",
    "storesHint": "Assignez au moins une boutique",
    "storesRequired": "Sélectionnez au moins une boutique",
    "teamLead": "Responsable d'équipe",
    "teamLeadPlaceholder": "Sélectionnez un responsable",
    "leadRequired": "Sélectionnez un responsable",
    "spendingLimit": "Limite de dépenses",
    "spendingLimitHint": "Laisser vide pour aucune limite",
    "save": "Enregistrer",
    "saving": "Enregistrement..."
  },
  "confirm": {
    "deactivate": {
      "title": "Désactiver cette équipe ?",
      "body": "Toutes les boutiques seront libérées vers Non affectées et les membres déplacés vers aucune équipe. Cela peut être annulé en les réaffectant ultérieurement.",
      "confirm": "Désactiver l'équipe",
      "cancel": "Annuler"
    }
  },
  "toast": {
    "created": "Équipe créée",
    "updated": "Équipe mise à jour",
    "deactivated": "Équipe désactivée",
    "storesAssigned": "Boutiques affectées",
    "createFailed": "Impossible de créer l'équipe",
    "updateFailed": "Impossible de mettre à jour l'équipe",
    "deactivateFailed": "Impossible de désactiver l'équipe",
    "duplicateName": "Une équipe portant ce nom existe déjà"
  },
  "empty": {
    "title": "Aucune équipe pour le moment",
    "subtitle": "Créez une équipe pour regrouper vos boutiques et contrôler l'accès et le budget.",
    "cta": "Créez votre première équipe"
  },
  "error": {
    "loadFailed": "Impossible de charger les équipes.",
    "retry": "Réessayer",
    "forbidden": {
      "title": "Accès refusé",
      "body": "Vous n'avez pas la permission de gérer les équipes. Contactez le propriétaire de la boutique."
    }
  },
  "breadcrumb": {
    "settings": "Paramètres",
    "teams": "Équipes"
  },
  "scopeChanged": "L'accès aux boutiques a changé — actualisation",
  "filter": {
    "searchPlaceholder": "Rechercher des équipes",
    "status": "Statut",
    "statusAll": "Tous les statuts",
    "sort": "Trier"
  },
  "sort": {
    "nameAsc": "Nom (A–Z)",
    "nameDesc": "Nom (Z–A)",
    "spendDesc": "Dépense la plus élevée",
    "newest": "Plus récent"
  }
}
